module.exports = __webpack_public_path__ + "static/img/t7.061fef3d.png";